export default "__VITE_ASSET__dfd8b70e__"